/**
 * Common reducer:
 * init, locales, locale, origins, categories, devices, player, settings, messages
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 14.04.2016.
 */

import {PendingState, SuccessState, ErrorState} from '../../utils';

import {
  LOCALE_CHANGE,
  SETTINGS_STATE_CHANGE,
  INIT_APP,
  GET_METADATA,
  GET_METADATA_ON_LOGIN,
  GET_CATEGORIES,
  INIT_LH_SDK,
  SET_PLAYER,
  GET_USER_DEVICES,
  OPEN_MESSAGE,
  CLOSE_MESSAGE,
  SHOW_TOAST,
  HIDE_TOAST,
  SHARE_REQUEST_IN_AIR,
  SHARE_REQUEST_DONE,
  OPEN_PROFILE_FOR,
  CLOSE_ALL_PROFILES,
  RESET
} from '../../actions/common/actions-common';

import {
  WS_INCOMING_SHARING_REQUEST
} from '../../actions/ws/actions-ws';

import {LOG_IN, LOG_OUT} from '../../actions/auth/actions-auth';

import {ACTIONS} from '../../containers/Player';

import _get from 'lodash/get';
import _findIndex from 'lodash/findIndex';
import _omit from 'lodash/omit';

import Cookies from 'js-cookie';
import Config from '../../config';

const INIT_STATE = {
  init: {
    isInitPhase: true,
    initError: null,
    initProgress: 0
  },
  locales: Config.locales,
  locale: Cookies.getJSON('cur_locale') || Config.def_locale,
  origins: Cookies.getJSON('origins') || [],
  categories: [],
  devices: {
    user_devices: [],
    rdvr_devices: [],
    loading: false
  },
  profile: null,
  player: {
    stream_url: '',
    container: null,
    action: null,
    type: null,
    position: null,
    isDetached: false
  },
  bookmarks: {},
  shares: {},
  messages: [],
  toasts: [],
  settings: {
    isShown: false,
    tabId: null
  }
};

/**
 *
 * @param {object} state
 * @param {object} action
 * @param {*} action.payload
 * @param {string} action.type
 * @returns {object}
 */
export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case LOCALE_CHANGE:
      return {...state, locale: action.payload};

    case SuccessState(LOG_IN):
      return {
        ...state,
        init: {
          ...state.init,
          reInit: true
        }
      };

    case SuccessState(LOG_OUT):
      return {
        ...state,
        init: {
          ...state.init,
          reInit: true
        }
      };

    case RESET:
      return {
        ...state,
        init: {
          ...state.init,
          reInit: false
        }
      };

    case PendingState(INIT_APP):

      return {
        ...state,
        init: {
          isInitPhase: true,
          initError: false,
          initProgress: 0
        },
        devices: {
          ...state.devices,
          rdvr_devices: []
        }
      };

    case SuccessState(INIT_APP):

      return {
        ...state,
        init: {
          isInitPhase: false,
          initProgress: 100
        }
      };

    case ErrorState(INIT_APP):

      return {
        ...state,
        init: {
          isInitPhase: true,
          initError: true
        }
      };


    case SuccessState(INIT_LH_SDK):

      return {
        ...state,
        init: {
          isInitPhase: true,
          initError: false,
          initProgress: 50
        },
        devices: {
          ...state.devices,
          rdvr_devices: lh.common.rdvr_devices
        }
      };

    case ErrorState(INIT_LH_SDK):

      if (_get(Cookies.getJSON('v2_' + Config.operator_ext_id), 'user', 'guest') !== 'guest') {
        Cookies.remove('v2_' + Config.operator_ext_id, {path: ''});
        location.reload();
      }

      return {
        ...state,
        init: {
          isInitPhase: true,
          initError: false,
          initProgress: 10
        },
        devices: {
          ...state.devices,
          rdvr_devices: lh.common.rdvr_devices
        }
      };

    case SuccessState(GET_METADATA):

      return {
        ...state,
        categories: action.payload[0],
        favorites: action.payload[1],
        init: {
          isInitPhase: true,
          initError: false,
          initProgress: 90
        }
      };

    case SuccessState(GET_METADATA_ON_LOGIN):

      return {
        ...state,
        categories: action.payload[0],
        favorites: action.payload[1],
      };

    case SuccessState(GET_CATEGORIES):

      return {
        ...state,
        categories: action.payload
      };

    case SET_PLAYER:
      let isDetached = state.player.isDetached;

      if (action.payload.action === ACTIONS.CLOSE_DETACH) {

        isDetached = false;
      } else if (action.payload.action === ACTIONS.DETACH) {

        isDetached = true;
      }

      return {
        ...state,
        player: {
          ...action.payload,
          isDetached: isDetached
        }
      };

    case PendingState(GET_USER_DEVICES):
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: true
        }
      };

    case SuccessState(GET_USER_DEVICES):
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: false,
          user_devices: action.payload
        }
      };

    case WS_INCOMING_SHARING_REQUEST:

      return {
        ...state,
        shares: {
          ...state.shares,
          [action.payload.asset_id]: {
            ...action.payload,
            inAir: false
          }
        }
      };

    case SHARE_REQUEST_IN_AIR:

      return {
        ...state,
        shares: {
          ...state.shares,
          [action.payload]: {
            ...state.shares[action.payload],
            inAir: true
          }
        }
      };

    case SHARE_REQUEST_DONE:

      return {
        ...state,
        shares: _omit(state.shares, action.payload)
      };

    case OPEN_MESSAGE:
      return {
        ...state,
        messages: [
          ...state.messages,
          action.payload
        ]
      };

    case CLOSE_MESSAGE:
      let indexOfMessage = _findIndex(state.messages, {id: action.payload});
      let messages = [...state.messages];
      if (indexOfMessage !== -1) {

        messages.splice(indexOfMessage, 1);
      } else {

        console.warn('Cant close modal window with id=', action.payload);
      }

      return {
        ...state,
        messages: messages
      };

    case SHOW_TOAST:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          action.payload
        ]
      };

    case HIDE_TOAST:
      let indexOfToast = _findIndex(state.toasts, {id: action.payload});
      let toasts = [...state.toasts];
      if (indexOfToast !== -1) {

        toasts.splice(indexOfToast, 1);
      } else {

        console.warn('Cant close toast with id=', action.payload);
      }

      return {
        ...state,
        toasts: toasts
      };

    case SETTINGS_STATE_CHANGE:
      return {
        ...state, settings: {
          ...state.settings, ...action.payload
        }

      };

    case OPEN_PROFILE_FOR:
      return {
        ...state,
        profile: action.payload
      };

    case CLOSE_ALL_PROFILES:

      return {
        ...state,
        profile: 'null'
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/common/reducer-common.js